// export const DefaultLanguage = 'en-US';
export const DefaultLanguage = 'en';
export const DefaultLanguageCode = 42;

export const Language = {
    ENGLISH: 1,
    RUSSIAN: 2
};

export const LanguageName = {
    1: "English",
    2: "Russian"
};

export const LanguageCode = {
    1: "EN",
    2: "RU"
};

export const LanguageForApi = {
    "EN": 1,
    "RU": 2,
    "AM": 3
};

export const LanguageCodesArr = [
    "EN",
    "RU"
];


export const BetsType = {
    1: "win",
    2: "lose",
    3: "refund",
    "win": 1,
    "lose": 2,
    "refund": 3
}

export const TimeTicker = {
    6: "yellow",
    3: "red",
    0: "white"
}

export const SocketUpdateType = {
    0: "Ping",
    1: "Error",
    2: "RoundStart",
    3: "Card",
    4: "Odd",
    5: "Timer",
    6: "Result",
    7: "Bet",
    8: "Pair"
}
export const CardsSuit = {
    0: "None", // for joker
    1: "clubs",
    2: "diamonds",
    3: "hearts",
    4: "spades"
}


export const PlayerOddType = {
    0: "None",
    1: "Banker",
    2: "Player",
    3: "Both",
    "None" : 0,
    "Banker": 1,
    "Player": 2,
    "Both": 3
}

export const Prediction = {
    "Banker": 0,
    "Player": 1,
    "Tie": 2,
    "BankerPair": 3,
    "PlayerPair": 4,
    "PerfectPair": 5,
    "EitherPair": 6,
    0:"Banker",
    1:"Player",
    2:"Tie",
    3:"BankerPair",
    4:"PlayerPair",
    5:"PerfectPair",
    6:"EitherPair"
}

export const gameHistory = {
    0: "None",
    1: "Banker",
    2: "Player",
    3: "Tie",
    "None": 0,
    "Banker": 1,
    "Player": 2,
    "Tie": 3
}

export const CardSide = {
    0: "right",
    1: "center",
    2: "left"
}

export const CardName = [
    "2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K", "A"
]

export const CardTypeMap = {
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6",
    7: "7",
    8: "8",
    9: "9",
    10: "10",
    11: "J",
    12: "Q",
    13: "K",
    14: "A",
    15: "Joker1",
    16: "Joker2"
}

export const CardType = {
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7,
    "8": 8,
    "9": 9,
    "10": 10,
    "J": 11,
    "Q": 12,
    "K": 13,
    "A": 14,
    "Joker1": 15,
    "Joker2": 16
}

export const PairType = {
    0: "None",
    1: "Player",
    2: "Banker",
    3: "Both",
    "None": 0,
    "Player": 1,
    "Banker": 2,
    "Both": 3,
}

export const SocketReadyState = {
    "CONNECTING": 0,
    "OPEN": 1,
    "CLOSING": 2,
    "CLOSED": 3
}